app.component("calendarAvailability", {
	templateUrl: "app/src/js/components/calendarAvailability/calendarAvailability.html",
	controller: "calendarAvailabilityController",
	bindings: {
		
	},
});
app.controller("calendarAvailabilityController", [
	"$scope",
	"Session",
    "AppointmentAPI",
    "$modal",
	"$filter",
	"CalendarAvailabilityLiveUpdateService",
	"$q",
	function ($scope, Session,AppointmentAPI,$modal, $filter, CalendarAvailabilityLiveUpdateService, $q) {
        $scope.items = [];
        $scope.form = {
			week_number_recurrence: 1,
			is_available: true,
			start_time_local: moment().set({'hour':9,'minute':0, 'second':0, 'millisecond':0}).toDate(),
			end_time_local: moment().set({'hour':18,'minute':0,'second':0,'millisecond':0}).toDate(),
		};
		$scope.weekdayOptions = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"].map((t) => ({
			name: t.charAt(0) + t.substring(1).toLowerCase(),
			value: t,
		}));

		$scope.availabilityOptions=[
			{name: 'Available',value: true},
			{name: 'Unavailable', value: false},
		]

		$scope.frequencyOptions = [
			{ name: "Every one week", value: 1 },
			{ name: "Every two weeks", value: 2 },
			{ name: "Every three weeks", value: 3 },
			{ name: "Every four weeks", value: 4 },
		];



		this.$onInit = function () {
			$scope.Session = Session;
			$scope.API = AppointmentAPI;
			$scope.selectedPractice = Session.practice.id;
			$scope.practices = $scope.Session.practiceOptions;
			fetchAvailability();
			subscribeToLiveAvailabilityChanges();
		};

		// This screen edits the signed-in user's own availability, so the live updates that matter are
		// the same user in another tab, or an admin changing it underneath them. A delete costs nothing
		// here: this list holds the stored records, so the id alone is enough to drop one.
		function subscribeToLiveAvailabilityChanges() {
			CalendarAvailabilityLiveUpdateService.subscribe($scope, {
				isInView: function (change) {
					// Events only arrive on the session practice's channel, so a list showing one of the
					// user's other practices cannot be updated from them.
					if ($scope.selectedPractice !== Session.practice.id) {
						return false;
					}
					return CalendarAvailabilityLiveUpdateService.isForUser(change, Session.userId);
				},
				removeLocally: function (change) {
					return CalendarAvailabilityLiveUpdateService.removeById($scope.items, change.availabilityId);
				},
				reload: function () {
					fetchAvailability({ background: true });
				},
			});
		}

        $scope.practiceOnChange = function(){
			fetchAvailability();
        }



        function trimTime (time) {
            let hours = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours();
            let minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes();
            return `${hours}:${minutes}:00`;
        }

        $scope.delete = function (uuid) {
			$scope.API.isProcessing = true;
			let applyToAll = $scope.form.applyToAllUserPractices ?? false;
			$scope.API.deletePracticeAvailability($scope.selectedPractice,Session.userId, uuid, applyToAll)
				.then(
					function () {
                        fetchAvailability();
                    },
					function (e) {
                        $scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
                    }
				)
				.then(() => ($scope.API.isProcessing = false));
		};

        $scope.addNew = function () {
			$scope.API.isProcessing = true;
			let data = {};
			if ($scope.form.is_available) {
				data = {
					...$scope.form,
					recurrence_type: "NUMBERED_WEEK",
					availability_type: "CUSTOM",
					start_time_local: trimTime($scope.form.start_time_local),
					end_time_local: trimTime($scope.form.end_time_local),
					start_date_utc: moment($scope.form.start_date_utc).utc(true).toISOString(),
					date_occurrence_utc: moment($scope.form.start_date_utc).utc(true).toISOString(),
				};
			} else {
				if (!$scope.form.unavailableRange) {
					$scope.API.isProcessing = false;
					return;
				}
				const duration = $scope.form.unavailableRange.split("-");
				// The range picker writes DD/MMM/YYYY; parse with that format rather than browser Date parsing.
				const start_date_UTC = moment(duration[0].trim(), "DD/MMM/YYYY").utc(true).toISOString();
				const end_date_UTC = moment(duration[1].trim(), "DD/MMM/YYYY").utc(true).toISOString();
				data = {
					//NOTE: One of these is where the groupID needs to go.
					...$scope.form,
					recurrence_type: "NUMBERED_WEEK",
					availability_type: "UNAVAILABLE",
					day_recurrence: 'SUNDAY',
					start_time_local: trimTime($scope.form.start_time_local),
					end_time_local: trimTime($scope.form.end_time_local),
					start_date_utc: start_date_UTC,
					date_occurrence_utc: start_date_UTC,
					exception_dates: [
						{
							exception_date_utc: end_date_UTC
						}
					]
				};
				
				if ($scope.form.applyToAllUserPractices && $scope.form.applyToAllUserPractices) {
					$q.all($scope.practices.map((t) => $scope.API.addPracticeAvailability(t.id, Session.userId, data, $scope.form.applyToAllUserPractices)))
					.then(
						function () {
							fetchAvailability();
						},
						function () {
							$scope.serverErrorModal = $modal({
								scope: $scope,
								templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
								show: true,
								title: "CatTrax has encountered an error",
							});
						}
					)
					.then(() => {
						$scope.API.isProcessing = false;
						$scope.form = {
							week_number_recurrence: 1,
							is_available: true,
							start_time_local: moment().set({'hour':9,'minute':0, 'second':0, 'millisecond':0}).toDate(),
							end_time_local: moment().set({'hour':18,'minute':0,'second':0,'millisecond':0}).toDate(),
						};
						$scope.mainForm.$setPristine();
						// $scope.form = {};
					});
					return;
				}
			}
          
			$scope.API.addPracticeAvailability($scope.selectedPractice, Session.userId, data, $scope.form.applyToAllUserPractices)
				.then(
					function () {
						fetchAvailability();
					},
					function () {
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					}
				)
				.then(() => {
					$scope.API.isProcessing = false;
					$scope.form = {
						week_number_recurrence: 1,
						is_available: true,
						start_time_local: moment().set({'hour':9,'minute':0, 'second':0, 'millisecond':0}).toDate(),
						end_time_local: moment().set({'hour':18,'minute':0,'second':0,'millisecond':0}).toDate(),
					};
					$scope.mainForm.$setPristine();
					// $scope.form = {};
				});
		};

		// `options.background` runs the fetch without touching the shared AppointmentAPI.isProcessing
		// flag, so a live update caused by someone else does not disable this screen's controls.
        function fetchAvailability(options) {
			const background = !!(options && options.background);
			if (!background) {
				$scope.API.isProcessing = true;
			}
			$scope.API.getPracticeAvailability($scope.selectedPractice, Session.userId)
				.then(
					function (resp) {
					
                        $scope.items = resp.data;// filter(t=>t.recurrence_type === 'ONE_OFF');
                    },
					function (error) {}
				)
				.then(() => {
					if (!background) {
						$scope.API.isProcessing = false;
					}
				});
		}

		$scope.formatDate = function (item) {
			if (item.availability_type === "CUSTOM") {
				return $filter("date")(moment(item.start_date_utc).utc(false).toDate(), "dd/MM/yyyy");
			}

			// One-off leave booked from the personal calendar carries no exception date.
			if (!item.exception_dates || !item.exception_dates.length) {
				return $filter("date")(moment(item.start_date_utc).utc(false).toDate(), "dd/MM/yyyy");
			}

			return `${$filter("date")(moment(item.start_date_utc).utc(false).toDate(), "dd/MM/yyyy")} to ${$filter("date")(
				moment(item.exception_dates[0].exception_date_utc).utc(false).toDate(),
				"dd/MM/yyyy"
			)}`;
		};
	},
]);
